<template>
  <div class="body-container">
    <div class="box">
      <h2>企业注册</h2>
      <el-steps
        class="register-steps"
        :align-center="true"
        :active="active"
        finish-status="success"
      >
        <el-step title="填写手机号"></el-step>
        <el-step title="完善信息"></el-step>
        <el-step title="完成注册"></el-step>
      </el-steps>
      <div class="register-form register-check-mobile" v-show="active === 0">
        <el-form
          :model="checkMobileForm"
          :rules="checkMobileRule"
          ref="checkMobileForm"
          label-width="100px"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item label="手机号" class="is-required" prop="mobile">
            <el-input
              v-model="checkMobileForm.mobile"
              :maxlength="11"
              ref="mobile"
              placeholder="请输入手机号"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="短信验证码" class="is-required" prop="code">
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="checkMobileForm.code"
                  :maxlength="6"
                  placeholder="请输入短信验证码"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <div class="send-btn" :class="{ disabled: !canSendSms }">
                  <el-button
                    type="text"
                    :disabled="!canSendSms"
                    @click="sendSms()"
                    >{{ sendSmsInfo }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
            <div class="el-form-item__error" v-if="isSendSms">
              验证码已发送到你的手机，10分钟内输入有效
            </div>
          </el-form-item>
          <el-form-item prop="agree">
            <el-row>
              <el-col :span="24" style="width: auto">
                <el-checkbox v-model="checkMobileForm.agree"
                  >我已阅读并同意</el-checkbox
                >
                <a href="/privacy-policy" target="_blank">《三特隐私协议》</a>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="form-btn"
              native-type="submit"
              @click="submitForm('checkMobileForm')"
              >下一步</el-button
            >
          </el-form-item>
          <el-form-item>
            <span>已有账号，</span>
            <router-link to="/login">立即登录</router-link>
          </el-form-item>
        </el-form>
      </div>
      <div :class="companyForm.type == 2 ? 'register-form register-company muchItem' : 'register-form register-company' " v-show="active === 1">
        <el-form
          :model="companyForm"
          :rules="companyRule"
          ref="companyForm"
          label-width="100px"
          class="login-form"
          @submit.native.prevent
        >
          <el-form-item v-if="firstFlag === false" class="is-required" label="注册方式" prop="type">
            <el-radio @change="changeRegMethod" class="radioReset" v-model="companyForm.type" label="1">加入公司</el-radio>
            <el-radio @change="changeRegMethod" v-model="companyForm.type" label="2">创建公司</el-radio>
          </el-form-item>
          <el-form-item label="企业名称" prop="company_name">
            <el-input
              v-model="companyForm.company_name"
              :maxlength="30"
              placeholder="输入企业名称"
              auto-complete="off"
              v-if="companyForm.type === '2' || firstFlag === true"
            ></el-input>
            <el-select
              v-else
              v-model="companyForm.company_name"
              placeholder="选择企业名称"
              filterable
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在地" class="is-required" prop="company_address"
            v-if="companyForm.type === '2' || firstFlag === true"
          >
            <el-cascader
              :options="options"
              v-model="companyForm.company_address"
              placeholder="选择所在地"
            ></el-cascader>
          </el-form-item>
          <el-form-item v-if="companyForm.type === '2' || firstFlag === true" label="行业类型" prop="company_type">
            <el-select
              v-model="companyForm.company_type"
              placeholder="选择行业类型"
            >
              <el-option
                v-for="item in companyNature"
                :key="item.key"
                :label="item.text"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="companyForm.type === '2' || firstFlag === true" label="人员规模" prop="company_scale">
            <el-select
              v-model="companyForm.company_scale"
              placeholder="选择人员规模"
            >
              <el-option
                v-for="item in companySize"
                :key="item.key"
                :label="item.text"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="firstFlag === true" label="管理密码" prop="password">
            <el-input
              type="password"
              v-model="companyForm.password"
              :maxlength="30"
              placeholder="密码由数字和字母组合，长度不低于6位"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="companyForm.type === '2' || firstFlag === true" label="联系人姓名" prop="username">
            <el-input
              v-model="companyForm.username"
              :maxlength="10"
              placeholder="输入联系人姓名"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item v-show="companyForm.type === '2' || firstFlag === true" label="邮箱" prop="email">
            <el-input
              v-model="companyForm.email"
              :maxlength="30"
              placeholder="输入邮箱"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="产品版本" prop="product_version" ref="product_version">
            <el-select
              v-model="companyForm.product_version"
              placeholder="选择产品版本"
            >
              <el-option
                v-for="item in productVersion"
                :key="item.key"
                :label="item.text"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="companyForm.type === '2' || firstFlag === true" label="邀请码" prop="invitation_code">
            <el-input
              v-model="companyForm.invitation_code"
              :maxlength="8"
              placeholder="输入邀请码（选填）"
              auto-complete="off"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="form-btn"
              :loading="registering"
              native-type="submit"
              @click="submitCompanyForm('companyForm')"
              >注册</el-button
            >
          </el-form-item>
          <el-form-item>
            <span>已有账号，</span>
            <router-link to="/login">立即登录</router-link>
          </el-form-item>
        </el-form>
      </div>
      <div class="register-form register-complete" v-show="active === 3">
        <div class="register-complete-icon">
          <i class="el-icon-check"></i>
        </div>
        <div class="register-complete-title">恭喜您！ 帐号注册成功！</div>
        <div class="register-complete-info">
          您已获得7天免费试用！ {{ count }}秒后将自动跳转到登录页面！
        </div>
        <el-button type="primary" class="form-btn" @click="redirectToLogin()"
          >立即登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import districts from "@/const/districts.js";
import EnvConfig from "@/const/configs/env.config.js";
import { CommonHelper } from "@/utils/common.helper.js";

export default {
  name: "register",
  data() {
    axios
      .get(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/BaseDatas/List", null)
      .then((response) => {
        if (response.data.code === 0) {
          this.$data.companyNature = response.data.data.company_nature;
          this.$data.companySize = response.data.data.company_size;
          this.$data.options = this.getDistricts();
        }
      });

    const validateVerifyMobile = (rule, value, callback) => {
      if (/^1[0-9]{10,10}$/.test(value)) {
        axios
          .get(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Sites/verifyMobile", {
            params: { mobile: value },
          })
          .then((response) => {
            if (response.data.code === 0 && response.data.data) {
              /* 已经注册过 */
              this.firstFlag = false;
              this.getCompanyList();
            }else {
              /* 未注册 */
              this.firstFlag = true;
            }
            this.refreshCaptcha();
            callback();
          });
      } else if (!/^1[0-9]{10,10}$/.test(value)) {
        this.$data.canSendSms = false;
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };

    const validateCompanyAddress = (rule, value, callback) => {
      if (value && value.length === 0) {
        callback(new Error("所在地不能为空"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,30}$/.test(value)) {
        callback(new Error("密码由数字和字母组合"));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (
        value &&
        !/^([a-z0-9_\\.-]+)@([\da-z\\.-]+)\.([a-z\\.]{2,6})$/.test(value)
      ) {
        callback(new Error("邮箱格式错误"));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value) {
        this.$data.isSendSms = false;
        callback(new Error("短信验证码不能为空"));
      } else {
        callback();
      }
    };
    const validateInvitationCode = (rule, value, callback) => {
      if (value && !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{0,8}$/.test(value)) {
        callback(new Error("邀请码由8位数字、字母组成"));
      } else {
        callback();
      }
    };

    return {
      intervalSuccess: null,
      count: 3,
      active: 0,
      intervalSms: null,
      isSendSms: false,
      sendSmsInfo: "获取短信验证码",
      smsCountDown: 0,
      canSendSms: false,
      options: [],
      companyNature: [],
      companySize: [],
      checkMobileForm: {
        mobile: "",
        code: "",
        agree: false,
      },
      checkMobileRule: {
        mobile: [{ validator: validateVerifyMobile, trigger: "change" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      registering: false,
      companyForm: {
        type: "1",
        company_name: "",
        company_address: [],
        company_type: "",
        company_scale: "",
        product_version: "",
        password: "",
        username: "",
        email: "",
        mobile: "",
        invitation_code: "",
      },
      companyRule: {
        company_name: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
          { min: 3, message: "名称长度不能少于3个字", trigger: "blur" },
        ],
        company_address: [
          { validator: validateCompanyAddress, trigger: "change" },
        ],
        company_type: [
          { required: true, message: "行业类型不能为空", trigger: "change" },
        ],
        company_scale: [
          { required: true, message: "人员规模不能为空", trigger: "change" },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          { min: 6, message: "密码最少6位字符", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" },
        ],
        username: [
          { required: true, message: "联系人姓名不能为空", trigger: "blur" },
          { min: 2, message: "联系人姓名不能少于2个字", trigger: "blur" },
        ],
        email: [{ validator: validateEmail, trigger: "blur" }],
        invitation_code: [
          { validator: validateInvitationCode, trigger: "blur" },
        ],
        product_version: [{ required: true, message: '产品版本不能为空', trigger: 'change' }],
      },
      /* 产品版本 */
      // 1 《数字化管理》
      // 4 《数据化经营》
      // 8 《数字化管理》+《数据化经营》
      productVersion: [
        // { key: "1", text: "制造版" },
        // { key: "2", text: "商贸版" },
        // { key: "4", text: "阿米巴版" },
        // { key: "64", text: "OA版" },
        // { key: "16", text: "财务版" },
        // { key: "32", text: "进销存版" },
        // { key: "128", text: "客户管理版" },
        // { key: "256", text: "OA版+阿米巴版" },
        // { key: "8", text: "制造版+阿米巴版" },
        { key: "1", text: "《数字化管理》" },
        { key: "4", text: "《数据化经营》" },
        { key: "8", text: "《数字化管理》+《数据化经营》" },
        
      ],
      firstFlag: true,  /* 判断是否为首次注册 */
      companyList: [],  /* 企业名称list */

    };
  },
  mounted() {
    this.$refs.mobile.focus();
  },
  methods: {
    getDistricts() {
      const options = [];
      for (const provinceKey in districts["100000"]) {
        let provinc = {
          value: districts["100000"][provinceKey],
          label: districts["100000"][provinceKey],
          children: [],
        };
        for (const cityKey in districts[provinceKey]) {
          let city = {
            value: districts[provinceKey][cityKey],
            label: districts[provinceKey][cityKey],
            children: [],
          };
          for (const areaKey in districts[cityKey]) {
            let area = {
              value: districts[cityKey][areaKey],
              label: districts[cityKey][areaKey],
            };
            city.children.push(area);
          }
          provinc.children.push(city);
        }
        options.push(provinc);
      }
      return options;
    },
    redirectToLogin() {
      // 判断是否IE浏览器
      var isIE = !!window.ActiveXObject || "ActiveXObject" in window;
      console.log("是否是ie浏览器", isIE);
      if (isIE) {
        document.getElementById("incompatible_tip").style.cssText =
          "display:block;";
        return;
      }
      clearInterval(this.$data.intervalSuccess);
      location.href = location.origin + "/login";
    },
    refreshCaptcha() {
      this.$data.canSendSms = this.$data.smsCountDown <= 0;
    },
    getCompanyList() {
      axios.get(EnvConfig.JAVA_BASE_ADDR +"/v1/saas/Companys/companyAllList?mobile="+this.checkMobileForm.mobile ).then((res)=> {
        if(res.status == 200){
          this.companyList = res.data.data;
          this.companyForm.company_name = this.companyList[0].name;
        }
      })
    },
    sendSms() {
      const codeField = this.$refs["checkMobileForm"].fields[1];
      if (codeField.validateState) {
        codeField.resetField();
      }
      this.$data.canSendSms = false;
      const params = {
        mobile: this.$refs["checkMobileForm"].model.mobile,
        type: 3,
      };
      axios
        .post(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/SmsCodeLogs", params)
        .then((response) => {
          if (response.data.code === 0) {
            this.$data.isSendSms = true;
            this.$data.smsCountDown = 60;
            this.$data.sendSmsInfo = "60秒后重新获取";
            this.$data.intervalSms = setInterval(() => {
              this.$data.smsCountDown--;
              this.$data.sendSmsInfo = this.$data.smsCountDown + "秒后重新获取";
              if (this.smsCountDown <= 0) {
                this.$data.canSendSms = true;
                this.$data.sendSmsInfo = "获取短信验证码";
                clearInterval(this.$data.intervalSms);
              }
            }, 1000);
          } else {
            this.$alert(response.data.message, "", {
              customClass: "alert-login-error",
              type: "error",
              confirmButtonText: "确认",
            });
          }
        });
    },
    /* 注册方式切换 */
    changeRegMethod(e){
      this.companyForm = {
        type: e,
        company_name: "",
        company_address: [],
        company_type: "",
        company_scale: "",
        product_version: "",
        password: "",
        username: "",
        email: "",
        mobile: this.checkMobileForm.mobile,
        invitation_code: "",
      };
      this.$refs.companyForm.clearValidate();
      this.$nextTick(() => {
        this.$refs['companyForm'].clearValidate();
      });
      if(e == '1'){
        this.companyForm.company_name = this.companyList[0].name;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = {
            mobile: this.$refs[formName].model.mobile,
            code: this.$refs[formName].model.code,
            type: 3,
          };
          if (!this.$refs[formName].model.agree) {
            this.$alert("请阅读并勾选同意《三特隐私协议》", "", {
              customClass: "alert-login-error",
              type: "error",
              confirmButtonText: "确定",
            });
            return;
          }
          axios
            .post(
              EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Users/verifyCode",
              params
            )
            .then((response) => {
              if (response.data.code === 0) {
                this.$data.active++;
                this.$refs["companyForm"].model.mobile = params.mobile;
              } else {
                this.$alert(response.data.message, "", {
                  customClass: "alert-login-error",
                  type: "error",
                  confirmButtonText: "确定",
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    submitCompanyForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.$refs[formName].model);
          params.company_address = params.company_address.join();
          if(this.firstFlag === true){
            delete params.type
            params.password = CommonHelper.encypt(params.password);
          }
          this.$data.registering = true;
          axios
            .post(EnvConfig.JAVA_BASE_ADDR + "/v1/saas/Sites/Register", params)
            .then((response) => {
              let resData = response.data;
              if(resData.data && resData.data !== null){
                if (resData.code === 0) {
                  this.active = 3;
                  this.$data.count = 5;
                  this.intervalSuccess = setInterval(() => {
                    this.$data.count--;
                    if (this.$data.count <= 0) {
                      this.$data.registering = false;
                      this.redirectToLogin();
                    }
                  }, 1000);
                } else {
                  this.$alert(resData.message, "", {
                    customClass: "alert-login-error",
                    type: "error",
                    confirmButtonText: "确定",
                    callback: () => {
                      this.$data.registering = false;
                    },
                  });
                }
              }else{
                this.$alert(resData.message, "", {
                  customClass: "alert-login-error",
                  type: "error",
                  confirmButtonText: "确定",
                  callback: () => {
                    this.$data.registering = false;
                  },
                });
              }
            })
            .catch((error) => {
              this.$data.registering = false;
              this.$alert("服务器繁忙！请重试", "", {
                customClass: "alert-login-error",
                type: "error",
                confirmButtonText: "确定",
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-complete {
  text-align: center;
  &-icon {
    background-color: #13ce66;
    border-color: #13ce66;
    border-radius: 72px;
    width: 72px;
    height: 72px;
    line-height: 72px;
    font-size: 32px;
    color: #fff;
    display: inline-block;
    margin-bottom: 24px;
  }
  &-title {
    line-height: 32px;
    height: 32px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #0b1625;
    margin-bottom: 8px;
  }
  &-info {
    height: 22px;
    font-size: 14px;
    color: #666666;
    margin-bottom: 52px;
  }
}

.box {
  width: 800px;
  padding: 20px 60px 10px;
  > .register-form {
    margin: 0 auto;
    width: 504px;
  }
  .register-steps {
    margin-bottom: 20px;
  }
  h2 {
    margin: 0 0 20px 0;
  }
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  margin: 13px auto;
}
.muchItem {
  /deep/.el-form-item {
    margin-bottom: 17px;
  }
  /deep/.el-form-item__error{
    padding-top: 1px;
    font-size:11px;
    -webkit-transform:scale(1);
  }
}

@media (max-width: 768px) {
  .body-container {
    background: rgb(14, 80, 177);
  }
  .box {
    width: 94%;
    padding: 0 5%;
    margin-top: 50px;
    margin-bottom: 20px;
    h2 {
      padding-top: 20px;
    }
    /deep/ .el-step {
      .el-step__title {
        font-size: 14px;
      }
    }
    > .register-form {
      width: 100%;
      .el-form-item {
        margin-bottom: 10px;
        /deep/ .el-form-item__label {
          padding: 0;
          width: 80px !important;
          font-size: 12px;
          .el-input__inner {
            font-size: 12px;
            padding: 0 10px;
          }
        }
        /deep/ .el-form-item__content {
          margin-left: 90px !important;
          .el-input {
            .el-input__inner {
              font-size: 12px;
              padding: 0 10px;
            }
          }
          .el-row {
            .el-col-24 {
              font-size: 12px;
            }
          }
          .el-col-16 {
            width: 52%;
            .el-input__inner {
              font-size: 12px;
              padding: 0 10px;
            }
          }
          /deep/ .el-col-8 {
            .send-btn {
              width: 42%;
              span {
                font-size: 12px;
              }
            }
          }
        }

      }
    }
    .register-complete {
      .el-button {
        margin-bottom: 30px;
      }
    }
  }
}
</style>

<style lang="scss">
.el-cascader,
.el-select {
  width: 100%;
}
</style>
